import { QuickBooksImportErrorCodes } from '../enums/QuickBooksImportErrorCodeEnum'

// Minimal per-entry reference for the error table + associate payload.
// Local interface, not a standalone entity.
export interface QuickBooksImportErrorEntry {
  id: string // QuickBooks ListID (associate payload value); the Procurify id when the rejection lists Procurify records
  number: Nullable<string> // account number; null for vendor entries
  type: Nullable<string> // account type; null for vendor entries
  name: string
}

export interface QuickBooksImportErrorDetailConstructor {
  code: Nullable<string> // known values in QuickBooksImportErrorCodes; full set unconfirmed; null when the rejection has no code
  message: string
  entries: QuickBooksImportErrorEntry[]
}

export class QuickBooksImportErrorDetail {
  readonly code: Nullable<string>
  readonly message: string
  readonly entries: QuickBooksImportErrorEntry[]

  constructor(data: QuickBooksImportErrorDetailConstructor) {
    this.code = data.code
    this.message = data.message
    this.entries = data.entries
  }

  // Codes 0003/0009 show the "Duplicate entries detected" Proceed block
  // that associates entries (BHV-027).
  get isAssociatable(): boolean {
    return (
      this.code === QuickBooksImportErrorCodes.DUPLICATE_ENTRIES_0003 ||
      this.code === QuickBooksImportErrorCodes.DUPLICATE_ENTRIES_0009
    )
  }

  // Associate payload: the entry ids to link (BHV-027).
  get entryIds(): string[] {
    return this.entries.map((entry) => entry.id)
  }
}
